export enum CalledStatus {
  IN_QUEUE = 'IN_QUEUE',
  CONFIRMED = 'CONFIRMED',
  UNDEFINED = 'UNDEFINED',
}



// WEBPACK FOOTER //
// ./src/app/pages/call-attendant/enums/called-status.enum.ts